import { useMemo } from 'react';

import { useMultiTierCheckout } from '../../../context';
import SummaryItem from './SummaryItem';
import SummaryList from './SummaryList';
import useCheckoutSummary from '../../../hooks/useCheckoutSummary';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { currencyFormat } from 'legacy/common/utils/currency';

import styles from '../../../../Summary.module.scss';

type Props = {
  goToTicketsSelection: () => void;
};

const Summary = ({ goToTicketsSelection }: Props) => {
  const checkoutSummaryData = useCheckoutSummary();
  const {
    data: {
      tickets,
      ticketTiers,
      checkoutSession: { checkoutSession }
    }
  } = useMultiTierCheckout();

  const selectedTiersData = useMemo(
    () =>
      ticketTiers.data.filter(
        (tier) => !!tickets.selectedTicketTiers[tier._id]
      ),
    [tickets.selectedTicketTiers, ticketTiers.data]
  );

  // This is bad, sorry :(
  // TODO: Add an i18n system
  const itemsCountText =
    tickets.totalAmountOfTicketsSelected === 1
      ? `${tickets.totalAmountOfTicketsSelected} item`
      : `${tickets.totalAmountOfTicketsSelected} items`;

  return (
    <div className="flex flex-col border-b-1 mb-6">
      <div className="text-gray-400 text-lg mt-4 mb-4">
        Summary - {itemsCountText}
      </div>
      <ul className="flex flex-col gap-5">
        {selectedTiersData.map((selectedTier) => (
          <li key={selectedTier._id} className="border-b-1 pb-5">
            <SummaryItem tier={selectedTier} />
          </li>
        ))}
        <li>
          <Button type={ButtonType.Inverted} onClick={goToTicketsSelection}>
            Add more items
          </Button>
        </li>
      </ul>
      <SummaryList data={checkoutSummaryData} />
      <div className="flex justify-between border-t-1 py-4">
        <div>
          <div className={styles.totalTitle}>Total</div>
          <div className={styles.totalInfo}>Transfer + Fees</div>
        </div>
        <div className={styles.totalAmount}>
          {currencyFormat(checkoutSession.total)} {checkoutSession?.currency}
        </div>
      </div>
    </div>
  );
};

export default Summary;
